import React from "react";
import { Link } from "react-router-dom";
import { useQuery, gql } from "@apollo/client";
import RemoveMarkdown from "remove-markdown";

const REVIEWS = gql`
  query GetReviews {
    reviews {
      data {
        id
        attributes {
          title
          rating
          body
          categories {
            data {
              id
              attributes {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export default function Homepage() {
  const { loading, error, data } = useQuery(REVIEWS);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error :(</p>;

  return (
    <div>
      {data.reviews.data.map((review) => (
        <div key={review.id} className="review-card">
          <div className="rating">{review.attributes.rating}</div>
          <Link to={`/details/${review.id}`}>
            <h2>{review.attributes.title}</h2>
          </Link>

          <div>
            {review.attributes.categories.data.map((c) => (
              <small key={c.id}>{c.attributes.name}</small>
            ))}
          </div>

          <p>{RemoveMarkdown(review.attributes.body.substring(0, 200))}...</p>

          <Link to={`/details/${review.id}`}>Read more</Link>
        </div>
      ))}
    </div>
  );
}
